import {RandomNumber} from "@/mixins/RandomNumber.mixin";

export {
    RandomNumber
}
